import React, { useMemo, useState, useEffect } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Navigation, Pagination } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import img1 from '../images/1.jpg';
import img2 from '../images/2.jpg';
import img3 from '../images/3.jpg';
import img4 from '../images/4.jpg';
import img5 from '../images/5.jpg';
import '../styles/Diaporama.css';

const Diaporama = () => {
  const images = useMemo(() => [img1, img2, img3, img4, img5], []);
  const [imagesLoaded, setImagesLoaded] = useState(false);
  const [loadedCount, setLoadedCount] = useState(0);
  const [swiperInstance, setSwiperInstance] = useState(null);

  // Précharger les images
  useEffect(() => {
    const preloadImages = () => {
      let loaded = 0;
      
      images.forEach((src) => {
        const img = new Image();
        img.onload = () => {
          loaded++;
          setLoadedCount(loaded);
          if (loaded === images.length) {
            setImagesLoaded(true);
          }
        };
        img.onerror = () => {
          loaded++;
          setLoadedCount(loaded);
          if (loaded === images.length) {
            setImagesLoaded(true);
          }
        };
        img.src = src;
      });
    };

    preloadImages();
  }, [images]);

  // Mettre à jour Swiper quand les images sont chargées
  useEffect(() => {
    if (imagesLoaded && swiperInstance) {
      setTimeout(() => {
        swiperInstance.update();
        swiperInstance.slideTo(0, 0); // Aller à la première slide
      }, 100);
    }
  }, [imagesLoaded, swiperInstance]);

  // Afficher un loader pendant le chargement des images
  if (!imagesLoaded) {
    return (
      <div className="diaporama-loading">
        <div className="loading-spinner"></div>
        <p>Chargement des images... ({loadedCount}/{images.length})</p>
      </div>
    );
  }

  return (
    <Swiper
      className="home-swiper"
      modules={[Autoplay, Navigation, Pagination]}
      autoplay={{ delay: 4000, disableOnInteraction: false }}
      loop={true}
      centeredSlides={true}
      spaceBetween={0}
      slidesPerView={'auto'}
      navigation
      pagination={{ clickable: true }}
      breakpoints={{}}
      onSwiper={(swiper) => {
        setSwiperInstance(swiper);
        // Force la mise à jour de Swiper après initialisation
        setTimeout(() => {
          swiper.update();
        }, 200);
      }}
      observer={true}
      observeParents={true}
    >
      {images.map((src, idx) => (
        <SwiperSlide key={idx}>
          <img 
            src={src} 
            alt={`Diapo ${idx + 1}`} 
            loading="eager"
            style={{ 
              opacity: imagesLoaded ? 1 : 0,
              transition: 'opacity 0.3s ease'
            }}
          />
        </SwiperSlide>
      ))}
    </Swiper>
  );
};

export default Diaporama;